module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home",
    class: _vm.theme,
    attrs: {
      "id": "services-page"
    }
  }, [_c('nav-bar'), _vm._v(" "), _c('div', {
    staticClass: "page",
    attrs: {
      "id": "quote-form"
    }
  }, [_c('h1', {
    staticClass: "page__title"
  }, [_vm._v(_vm._s(_vm.$t('Contact')))]), _vm._v(" "), _c('hr', {
    staticClass: "page__hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "page__container main"
  }, [_c('div', {
    staticClass: "page__content left"
  }, [_c('span', [_c('icon', {
    attrs: {
      "name": "home",
      "scale": "1"
    }
  }), _vm._v(" Còrsega, 168, 1º 1ª, 08036 - Barcelona")], 1), _vm._v(" "), _c('span', [_c('icon', {
    attrs: {
      "name": "phone",
      "scale": "1"
    }
  }), _vm._v(" (+34) 93 410 05 32")], 1), _vm._v(" "), _c('span', [_c('icon', {
    attrs: {
      "name": "envelope",
      "scale": "1"
    }
  }), _vm._v(" info@barnatasa.com")], 1)]), _vm._v(" "), _c('div', {
    staticClass: "page__content right"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('Office_hours')) + ":")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.$t('Mon.')) + " " + _vm._s(_vm.$t('to')) + " " + _vm._s(_vm.$t('Thu.')) + ": "), _c('strong', [_vm._v(_vm._s(_vm.$t('from')) + " 09:00h " + _vm._s(_vm.$t('to')) + " 13:00h")]), _vm._v(" " + _vm._s(_vm.$t('and')) + " " + _vm._s(_vm.$t('from')) + " "), _c('strong', [_vm._v("16:00h " + _vm._s(_vm.$t('to')) + " 19:00h")])]), _vm._v(" "), _c('li', [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.$t('Fri.')) + ": "), _c('strong', [_vm._v(_vm._s(_vm.$t('from')) + " 09:00h " + _vm._s(_vm.$t('to')) + " 14:00h")])]), _vm._v(" "), _c('li', [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.$t('Sat.')) + " " + _vm._s(_vm.$t('and')) + " " + _vm._s(_vm.$t('Sun.')) + ": "), _c('strong', [_vm._v(_vm._s(_vm.$t('closed')))])])])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "20vh"
    }
  }), _vm._v(" "), _c('logo-bar'), _vm._v(" "), _c('footer-bar')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c7d98316!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Contact.vue
// module id = 2185
// module chunks = 0